<template>
  <div
    class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-left mt-3"
    v-if="avulso"
  >
    <ed-modal
      title="INSERIR NOVO PROCEDIMENTO"
      :modal="showProcedimento"
      :onSave="inserirProcedimento"
      :isModal="false"
      width="50%"
    >
      <div slot="modal-content">
        <ed-input-auto-complete
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pa-0"
          label="Pesquisar procedimento"
          v-model="bind.procedimento"
          :items="bind.procedimentos"
          :loading="bind.loadingProcedimento"
          @search="getProcedimento"
          clearable
          is-object
        />
      </div>
    </ed-modal>

    <div class="item-group">Informações da Consulta</div>

    <div class="row">
      <ed-input-date
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4"
        label="Data da Consulta"
        v-model="formData.consulta.aso_dt"
        :maxDaysTomorrow="1"
        required
      />

      <ed-input-select-tipo
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4"
        label="Tipo de Consulta"
        name="id_tipo_aso"
        tipo="46"
        v-model="formData.consulta.id_tipo_aso"
        required
      />

      <ed-input-select-tipo
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4"
        label="Aptidão"
        name="id_tipo_aptidao"
        tipo="185"
        v-model="formData.consulta.aptidao"
        required
      />
    </div>

    <div class="item-group mt-2">Informações do Médico Examinador</div>

    <div class="row">
      <ed-input-text
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4"
        label="Nome do Médico"
        v-model="formData.medico.nome"
        name="valor.medico.nome"
        required
      />

      <ed-input-text
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4"
        label="CRM do Médico"
        v-model="formData.medico.crm"
        name="valor.medico.crm"
        type="number"
        required
      />

      <ed-input-select
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4"
        label="Unidade Federativa do CRM"
        name="valor.medico.crm_uf"
        :items="parent.bind.estados"
        v-model="formData.medico.crm_uf"
        required
      />
    </div>

    <div class="item-group mt-2">
      Informações do Médico Coordenador do PCMSO
    </div>

    <div class="row">
      <ed-input-text
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4"
        label="Nome do Médico"
        v-model="formData.responsavel_pcmso.nome"
        name="valor.responsavel_pcmso.nome"
      />

      <ed-input-text
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4"
        label="CRM do Médico"
        v-model="formData.responsavel_pcmso.crm"
        name="valor.responsavel_pcmso.crm"
        type="number"
      />

      <ed-input-select
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4"
        label="Unidade Federativa do CRM"
        :items="parent.bind.estados"
        v-model="formData.responsavel_pcmso.crm_uf"
        name="valor.responsavel_pcmso.crm_uf"
      />
    </div>

    <div class="item-group mt-2">Procedimentos - Tabela 27 do eSocial</div>

    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <ed-button
          icon="fa fa-plus-circle"
          type="success"
          label="Inserir Novo Exame"
          title="Inserir Novo Exame"
          @click="showProcedimento = !showProcedimento"
        />

        <b-table-simple
          id="table-v0"
          class="col-12 table-v2 mt-1"
          small
          outlined
          borered
        >
          <b-thead>
            <b-tr>
              <b-th width="150">CÓDIGO</b-th>
              <b-th>EXAME</b-th>
              <b-th>DATA DO EXAME</b-th>
              <b-th>RESULTADO</b-th>
              <b-th width="150"></b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-if="!formData.exames.length">
              <b-td colspan="5" align="center"> Nenhum exame cadastrado </b-td>
            </b-tr>
            <b-tr v-for="(exame, index) in formData.exames" :key="index">
              <b-td>
                {{ exame.codigo }}
              </b-td>
              <b-td>
                {{ exame.nome }}
              </b-td>
              <b-td>
                <ed-input-date
                  style="with:100%"
                  v-model="exame.data"
                  :maxDaysTomorrow="1"
                  required
                />
              </b-td>
              <b-td>
                <ed-input-select
                  style="with:100%"
                  :items="[
                    { id: 1, nome: 'Normal' },
                    { id: 2, nome: 'Alterado' },
                    { id: 3, nome: 'Estável' },
                    { id: 4, nome: 'Agravamento' },
                  ]"
                  v-model="exame.resultado"
                  required
                />
              </b-td>
              <b-td>
                <ed-button
                  icon="fa fa-trash"
                  type="danger"
                  title="Remover Novo Exame"
                  @click="removerProcedimento(index)"
                />
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
    </div>
  </div>
</template>

<script>
import Fct from "common/fct";
import {
  EdButton,
  EdInputText,
  EdInputDate,
  EdInputAutoComplete,
  EdInputSelect,
  EdInputSelectTipo,
  EdModal,
} from "template";

export default {
  name: "esocial-s2220",
  mixins: [Fct],
  components: {
    EdButton,
    EdInputText,
    EdInputDate,
    EdInputAutoComplete,
    EdInputSelect,
    EdInputSelectTipo,
    EdModal,
  },

  props: {
    avulso: {
      type: Number,
      default: 0,
    },
    formData: {
      type: Object,
      default: function () {
        return {};
      },
    },
    parent: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },

  watch: {
    "parent.response"() {
      this.formataLista();
    },
  },

  data() {
    return {
      bind: {
        procedimento: null,
        procedimentos: [],
        loadingProcedimento: false,
      },
      tableHead: [
        {
          key: "empresa",
          sortable: true,
          show_fdt: true,
          show_empresa_link: true,
          label: "Empresa",
        },
        {
          key: "funcionario",
          sortable: true,
          show_funcao: true,
          show_funcionario_link: true,
          label: "Funcionário",
        },
        {
          key: "consulta",
          sortable: true,
          show_consulta_link: true,
          label: "Consulta",
        },
        {
          key: "recibo",
          sortable: true,
          label: "Recibo",
        },
        {
          key: "lote",
          sortable: true,
          show_lote_link: true,
          label: "Lote",
        },
        {
          key: "tipo_status",
          sortable: true,
          label: "Status",
        },
        {
          key: "updated_at",
          sortable: true,
          show_user: true,
          label: "Data Atualização",
        },
      ],
      showProcedimento: false,
    };
  },

  mounted() {
    if (!this.avulso) {
      this.formataLista();
    } else {
      this.getProcedimento();
    }
  },

  methods: {
    inserirProcedimento() {
      if (this.bind.procedimento) {
        let encontrado = false;

        this.formData.exames.forEach(element => {
            if(element.codigo == this.bind.procedimento.codigo){
              encontrado = true
            }
        });

        if (encontrado) {
          this.$root.$dialog.alert("Procedimento já foi inserido", "warning");
          return;
        }

        this.formData.exames.push({
          codigo: this.bind.procedimento.codigo,
          nome: this.bind.procedimento.nome,
          data: this.$utilidade.toDate(null,true),
          resultado: 1,
        });
        this.showProcedimento = !this.showProcedimento
      }
    },

    removerProcedimento(index) {
      this.formData.exames.splice(index, 1);
    },

    getProcedimento(_search) {
      this.bind.procedimentos = [];
      this.bind.loadingProcedimento = false;

      this.$root.$request
        .get("esocial/tabelas/conteudo/27", {
          search: _search,
          pagination: 100,
        })
        .then((result) => {
          this.bind.loadingProcedimento = false;

          if (result.status == 200) {
            result.data.data.forEach((element) => {
              let item = {
                id: element.id,
                codigo: element.codigo,
                nome: element.codigo + " - " + element.nome,
              };

              if (item.nome.length > 50) {
                item.nome = item.nome.substring(0, 100);
              }

              this.bind.procedimentos.push(item);
            });
          }
        });
    },

    formataLista: function () {
      if (!this.parent || !this.parent.response) return;

      var result = this.parent.response;

      this.parent.tableHead = this.tableHead;

      if (!result.data || !result.data.data) {
        this.parent.tableData = [];
        return;
      }

      var tableData = [],
        arrData = result.data.data;

      for (var i = 0; i < arrData.length; i++) {
        arrData[i]._nome =
          arrData[i].empresa.nome + " - " + arrData[i].funcionario.nome;
        arrData[i].funcao = arrData[i].funcionario.funcao
          ? arrData[i].funcionario.funcao
          : null;
        arrData[i].fdt = arrData[i].funcionario.fdt
          ? arrData[i].funcionario.fdt
          : null;
        arrData[i].consulta = arrData[i].consulta ? arrData[i].consulta : null;

        let lote = "";

        if (arrData[i].lote) {
          lote = "<span>";
          lote +=
            '<span style="color:' +
            (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") +
            '"><i class="fa fa-plus"></i> Lote inclusão ' +
            arrData[i].lote +
            "</span>";
          lote += "</span>";
        }

        if (arrData[i].lote_exclusao) {
          lote +=
            '<br><a target="_blank" href="/esocial/lotes/' +
            arrData[i].lote_exclusao +
            '">';
          lote +=
            '<span style="color:' +
            (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") +
            '"><i class="fa fa-times"></i> Lote exclusão ' +
            arrData[i].lote_exclusao +
            "</span>";
          lote += "</a>";
        }
        var item = {
          consulta: arrData[i].id_con,
          id_con: arrData[i].id_con,
          empresa: arrData[i].empresa.nome,
          funcionario: arrData[i].funcionario.nome,
          funcao: arrData[i].funcao ? arrData[i].funcao.nome : null,
          tipo_status: arrData[i].tipo_status
            ? arrData[i].tipo_status.descricao
            : null,
          fdt: arrData[i].fdt,
          id: arrData[i].id,
          lote: lote ? lote : "----",
          recibo:
            '<span style="color:' +
            (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") +
            '">' +
            (arrData[i].recibo ? arrData[i].recibo : "---") +
            "</span>",
          updated_at:
            '<span style="color:' +
            (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") +
            '">' +
            this.toDate(arrData[i].updated_at, false) +
            "</span>",
          dt_cad:
            '<span style="color:' +
            (arrData[i].tipo_status ? arrData[i].tipo_status.cor : "") +
            '">' +
            this.toDate(arrData[i].created_at, false) +
            "</span>",
          _data: arrData[i],
          buttons: [],
          options: {
            disable_delete:
              arrData[i].tipo_status &&
              [332, 330].indexOf(arrData[i].tipo_status.id) != -1 &&
              arrData[i].recibo &&
              this.$root.$session.validarPermissao(586)
                ? false
                : true,
          },
        };

        if (!arrData[i].recibo && !arrData[i].xml) {
          item.buttons.push({
            icon: "fa fa-file-text-o",
            color: "default",
            title: "Gerar arquivo XML",
            style: "color:#e03a3a",
            click: this.parent.onEdit,
          });
        } else {
          item.buttons.push({
            icon: "fa fa-file-text-o",
            color: "default",
            title: "Baixar arquivo XML",
            style: "color:#34c142",
            click: this.parent.onDownloadXML,
          });

          if (!arrData[i].lote) {
            item.buttons.push({
              icon: "fa fa-file-archive-o",
              color: "default",
              title: "Gerar novo lote para esse arquivo",
              style: "color:#666",
              click: this.parent.onGerarLote,
            });
          }

          if (!arrData[i].recibo) {
            item.buttons.push({
              icon: "fa fa-refresh",
              color: "default",
              title: "Atualizar arquivo XML",
              style: "color:#568cdd",
              click: this.parent.onEdit,
            });
          }

          if (
            arrData[i].recibo &&
            arrData[i].tipo_status &&
            [332, 335].indexOf(arrData[i].tipo_status.id) != -1
          ) {
            item.buttons.push({
              icon: "fa fa-times-circle",
              color: "default",
              title: "Excluir arquivo XML",
              style: "color:#d82d2d",
              click: this.parent.onDelete,
            });
          }
        }

        //LOGS
        if (arrData[i].log_erro.length || arrData[i].log_warning.length) {
          item.buttons.push({
            icon: "fa fa-exclamation-triangle faa-flash animated",
            color: "default",
            title:
              item._data.log_erro.length +
              item._data.log_warning.length +
              " conflito(s) encontrado(s)",
            style: "color:" + (arrData[i].log_erro.length ? "red" : "#ff8300"),
            click: this.parent.onLogs,
          });
        }

        tableData.push(item);
      }

      this.parent.tableData = tableData;
      this.parent.pagination = result.data;
    },
  },
};
</script>



// WEBPACK FOOTER //
// s2220.vue?9b57d158